import React from 'react';
import './Free.css'

const Free = () => {
    return (
        <div className="free-bg">
            <h1 className="text-dark free fw-bold">Free <br /> cancellation</h1>
            <p>You'll receive a full refund if you cancel at <br /> least 24 hours in advance of most <br /> experiences.
</p>
        </div>
    );
};

export default Free;